import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {router} from 'lit-element-router';
import {msg} from '@lit/localize';
import store from '../store';

import getRoutes from '../routes';

@customElement('language-switch')
export class LanguageSwitch extends connect(store)(router(LitElement)) {

	static styles = [
		css`
			:host {
				margin-right: var(--padding);
				display: flex;
			}

			.languages {
				color: var(--color-white);
			}

			.label {
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				display: block;
				padding-bottom: var(--very-small-padding);
			}

        `
	];

	@property({type: Object})
	params = {};

	static get routes() {
		return getRoutes();
	}

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	router(route, params, query, data) {
		this.params = params;
	}
	stateChanged(state) {
		this.dashboardActive = state.status.dashboardActive;
		this.specsheetActive = state.status.specsheetActive;
	}


	render() {
		return html`
			<div class="languages">
				<div class="label">${msg('Language')}:</div>
				<router-link .active=${this.params.language === 'de'} class="language" .params=${{language: 'de'}}>de</router-link>
				<router-link .active=${this.params.language === 'en'} class="language" .params=${{language: 'en'}}>en</router-link>
				<router-link .active=${this.params.language === 'fr'} class="language" .params=${{language: 'fr'}}>fr</router-link>
			</div>
		`;
	}
}
